angular.module('app').directive('loaderDir', function(){
    return{
        restrict: 'AE',
        templateUrl: './views/directives/loaderDir.html'
    }
})